import m from "mithril"
import { MithrilTsxComponent } from "mithril-tsx-component"
import { dialog } from "oj-mithriljs-packages/dist/Dialog/Dialog"
import { animateClassNames, animateCreate, animateRemove } from "oj-mithriljs-utils"
import { cleanString } from "oj-utils"
import { chooseStoreConfirmDialog, StoreDialog } from "./dialog"
import { getTranslation } from "./translations"
import { IStore, isStoreOpen, formatTime, getNextOpen, ICoords, getStoreOpenState } from "./utils"
import { Svg } from "../../svg"

export interface IStoreItem extends IStore {
    isExpressService: boolean,
    onselect: () => void,
    currentgeo?: ICoords,
}

export class StoreItem extends MithrilTsxComponent<IStoreItem> {
    open: ReturnType<typeof getStoreOpenState> | "disabled"
    openStr: string

    oninit(v: m.Vnode<IStoreItem>) {
        if (!v.attrs.isActive) {
            this.open = "disabled"
            this.openStr = v.attrs.isExpressService ? getTranslation("storeTempUnavailable") : getTranslation("closed")
            return
        }

        const { open, day, index } = isStoreOpen(v.attrs.days)
        this.open = open

        if (this.open === "open")
            this.openStr = getTranslation("todayOpenUntil")(formatTime(day.closingTime.hour, day.closingTime.minute))
        else if (this.open === "future" && day.openingTime)
            this.openStr = getTranslation("todayOpenFuture")(formatTime(day.openingTime.hour, day.openingTime.minute), formatTime(day.closingTime.hour, day.closingTime.minute))
        else {
            const [dayName, day] = getNextOpen(v.attrs.days, index) ?? []
            if (dayName && day.openingTime)
                this.openStr = getTranslation("nextDayOpenFrom")(dayName, formatTime(day.openingTime.hour, day.openingTime.minute))
            else
                this.openStr = getTranslation("closed")
        }
    }

    view(v: m.Vnode<IStoreItem>) {
        return <div className={cleanString("store-item", this.open === "disabled" && "disabled")}>
            {v.attrs.hasXlService && <div className="store-label">
                <span>{getTranslation("hasXlService")}</span>
            </div>}
            <div className="store-item-container">
                <div className="store-info">
                    <span className="store-city">{v.attrs.city}</span>
                    <span className="store-address">{v.attrs.address}</span>
                    <span className={cleanString("store-hours", `${["open", "future"].includes(this.open) ? "open" : "closed"}`)}>{this.openStr}</span>
                </div>
                <span className="store-location">
                    {v.attrs.distance.toFixed(2)} km
                    <button type="button" className="icon-link" onclick={() => this.openStoreInfoDialog(v)}>
                        <i className="icon"><Svg src="/FrontendWebpack/dist/assets/newIcons/info.svg" /></i>
                    </button>
                </span>
                <div className="store-submit">
                    {v.attrs.isExpressService && this.open === "open"
                        ? <a className="btn-default small" href={v.attrs.navigationUrl}>
                            <span>{getTranslation("chooseStore")}</span>
                        </a>
                        : <button disabled={this.open === "disabled"} type="button" className="btn-default small"
                            onclick={() => {
                                this.storeSelect(v)
                            }}>
                            <span>{getTranslation("chooseStore")}</span>
                        </button>
                    }
                </div>
            </div>
        </div>
    }

    storeSelect(v: m.Vnode<IStoreItem>) {
        if (this.open === "disabled")
            return
        else if (v.attrs.isExpressService)
            chooseStoreConfirmDialog(v, { onselect: v.attrs.onselect, open: this.open })
        else 
             v.attrs.onselect();            
    }

    oncreate(v: m.VnodeDOM<IStoreItem>) {
        animateCreate(v)
    }

    onbeforeremove(v: m.VnodeDOM<IStoreItem>) {
        return animateRemove(v)
    }

    openStoreInfoDialog(v: m.Vnode<IStoreItem>) {
        dialog({
            dismiss: true,
            animate: true,
            content: close =>
                <StoreDialog {...v.attrs}
                    isExpressService={v.attrs.isExpressService}
                    onclose={() => close()}
                    onselect={() => {
                        close()
                        v.attrs.onselect()
                    }}
                />
        })
    }
}
